import React from "react";
import { NavLink, Link } from "react-router-dom";
import { RiHomeFill } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import { categories } from "../utils/data";
import Logo from "../assets/Logo.png";
const isActiveStyleNot =
  `flex items-center text-lg px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize`;
const isActiveStyle =
  `flex items-center text-lg px-5 gap-3 font-extra-bold border-r-2 border-block  hover:text-black transition-all duration-200 ease-in-out capitalize`;



export default function Sidebar({ user, closeToggle }) {
  const handleCloseSidebar = () => {
    if (closeToggle) closeToggle(false);
  };

  return (
    <div className="flex flex-col justify-between h-full overflow-y-scroll min-w-210">
      <div className="flex flex-col">
        <Link
          to="/"
          className="flex px-5 gap-2 my-6 pt-1 w-190 items-center"
          onClick={handleCloseSidebar}
        >
          <img src={Logo} alt="logo" className="w-full" />
        </Link>
        <div className="flex flex-col gap-5">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? isActiveStyle : isActiveStyleNot
            }
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink>
          <h3 className="mt-2 px-5 text-base 2xl:text-xl">
            Discover Categories
          </h3>

          {categories.slice(0, categories.length - 1).map((category) => (
            
            <NavLink
            to={`/category/${category.name}`}

              className={({ isActive }) =>
                isActive ? isActiveStyle : isActiveStyleNot
              }
              onClick={handleCloseSidebar}
              key={category.name}
            >
              <img src={category.image} className="w-8 h-8 shadow-md rounded-full text-lg" alt="folder icon" />
              {category.name}
            </NavLink>
          ))}
        </div>
      </div>
      {user && (
        <Link
          to={`user-profile/${user._id}`}
          onClick={handleCloseSidebar}
          className="flex my-5 mb-3 gap-2 p-2 items-center text-xl  bg-white rounded-lg"
        >
          <img
            src={user.image}
            className="w-12 h-12 rounded-r-lg"
            alt="user-profile"
          />
          <p>{user.userName}</p>
        </Link>
      )}
    </div>
  );
}
